import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';

var TagEnhancedComponent = /** @class */ (function (_super) {
    __extends(TagEnhancedComponent, _super);
    /*
        This can be used not only for games but all square/rectangular
        components In order to use this component in other places, be sure to add
        this tag class in the same component:
    
        .tag {
            position: absolute;
            top: 0;
            left: 0;
            transition: opacity $duration ease;
            will-change: opacity;
            z-index: 2;
        }
    
        and to the parent component add 'overflow: hidden;'
    
        To add new variants, add a tag in the CMS with a game
        with the desired name i.e 'popular', then make a translation in this format: game.tag.popular
        Once added, add to the GameTag enum with a new value like: POPULAR = 'popular' and then you'll be able to create a
        popular variant in this css file.
    
        
    */
    function TagEnhancedComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], TagEnhancedComponent.prototype, "variant", void 0);
    TagEnhancedComponent = __decorate([
        Component({
            name: 'ui-tag-enhanced',
        })
        /*
            This can be used not only for games but all square/rectangular
            components In order to use this component in other places, be sure to add
            this tag class in the same component:
        
            .tag {
                position: absolute;
                top: 0;
                left: 0;
                transition: opacity $duration ease;
                will-change: opacity;
                z-index: 2;
            }
        
            and to the parent component add 'overflow: hidden;'
        
            To add new variants, add a tag in the CMS with a game
            with the desired name i.e 'popular', then make a translation in this format: game.tag.popular
            Once added, add to the GameTag enum with a new value like: POPULAR = 'popular' and then you'll be able to create a
            popular variant in this css file.
        
            
        */
    ], TagEnhancedComponent);
    return TagEnhancedComponent;
}(Mixins(MagicConfigMixin)));

export default TagEnhancedComponent;
